import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-botao-submit',
  templateUrl: './botao-submit.component.html',
  styleUrls: ['./botao-submit.component.scss']
})
export class BotaoSubmitComponent {
  @Input() primary: boolean = true;
  @Input() disabled = false;
  constructor() {}
}
